import React from 'react';

import { useState, useEffect } from "react";
import { Container, Row, Col } from 'react-bootstrap';
import ReactLoading from 'react-loading';
import { useParams } from 'react-router-dom';
import ImageLightbox from '../components/ImageLightbox';

const Section = () => {
    const { categoryPath } = useParams();
    //    const [filters, setFilters] = useState([]);
    const [products, setProducts] = useState([]);
    //    const [selectedFilters, setSelectedFilters] = useState([]);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [lightboxImage, setLightboxImage] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const url = `${process.env.REACT_APP_BACKEND_API}/section/${categoryPath || 'home'}`;

                const response = await fetch(url, {
                    method: "GET",
                    mode: 'cors'
                });
                const data = await response.json();
                //                setFilters(data.filters);
                setProducts(data.products);
                setFilteredProducts(data.products);
            } catch (error) {
                console.log(error);
            }
        };

        fetchData();
    }, [categoryPath]);

    /*
    const handleFilterChange = (filterProperty, filterValue, checked) => {
        const newSelectedFilters = [...selectedFilters];
        const filter = newSelectedFilters.find(({ property }) => property === filterProperty);

        if (filter) {
            if (!checked) {
                const index = filter.values.indexOf(filterValue);
                filter.values.splice(index, 1);
            } else {
                filter.values.push(filterValue);
            }
        } else {
            newSelectedFilters.push({ property: filterProperty, values: [filterValue] });
        }

        const activeFilters = newSelectedFilters.filter(f => f.values.length > 0);
        const newFilteredProducts = activeFilters.length > 0
            ? products.filter(product => activeFilters.every(filter => filter.values.includes(product.properties[filter.property])))
            : products;

        setSelectedFilters(newSelectedFilters);
        setFilteredProducts(newFilteredProducts);
    };
    */

    // Load reCAPTCHA script once
    useEffect(() => {
        if (!window.grecaptcha) {
            const script = document.createElement('script');
            script.src = `https://www.google.com/recaptcha/api.js?render=${process.env.REACT_APP_RECAPTCHA_KEY}`;
            script.async = true;
            document.body.appendChild(script);
        }
    }, []);

    // Handler for the link click
    const handleRecaptchaClick = async (e) => {
        e.preventDefault();
        if (window.grecaptcha) {
            window.grecaptcha.ready(function () {
                window.grecaptcha.execute(`${process.env.REACT_APP_RECAPTCHA_KEY}`, { action: 'submit' }).then(async function (token) {
                    const url = `${e.target.href}&t=${token}`;
                    try {
                        // Await the fetch response
                        const response = await fetch(url, {
                            method: 'GET',
                            redirect: 'manual'
                        });

                        if (response.status === 200) {
                            const data = await response.json();
                            const location = data.redirect;
                            window.open(location, '_blank', 'noreferrer');
                        } else if (response.status >= 400 && response.status < 500) {
                            console.error('Unexpected response status: ' + response.status);
                        }
                    } catch (error) {
                        console.error(error);
                    }
                });
            });
        } else {
            console.log("reCAPTCHA not loaded yet.");
        }
    };

    const productList = filteredProducts.length ? filteredProducts : products;

    return (
        <>
            <section className="women-banner spad">
                <Container fluid>
                    <Row className="row-cols-3=auto">
                        {/*
                        <Col className="filter-section">
                            <hr></hr>
                            <strong>Filtros</strong>
                            <hr></hr>
                            <Form>
                                {filters.map((filter, i) => (
                                    <React.Fragment key={i}>
                                        <div className="filter-form">
                                            <strong>{filter.name}</strong>
                                        </div>

                                        <div className="mb-3 filter-form">
                                            {filter.values.map((value) => (
                                                <Form.Check key={filter.property + '_' + value} type="checkbox" id={filter.property} label={value} onChange={(event) => handleFilterChange(filter.property, value, event.target.checked)} />
                                            ))}
                                        </div>
                                        <hr />
                                    </React.Fragment>
                                ))}
                            </Form>
                        </Col>
                        */}

                        <Col>
                            <div className="product-card">
                                {productList.length ? productList.map((product) => (
                                    <div key={product.id} className="product-item">
                                        <div className="pi-pic" onClick={() => setLightboxImage(`${process.env.REACT_APP_IMAGE_URL}/${product.id}.jpeg`)}>
                                            <img 
                                                src={`${process.env.REACT_APP_IMAGE_URL}/${product.id}.jpeg`}
                                                alt={product.name}
                                                style={{ width: '100%', height: 'auto', display: 'block' }}
                                            />
                                        </div>
                                        <div className="pi-text">
                                            <div className="catagory-name">{product.category}</div>
                                            <h5>{product.name}</h5>
                                            <div className="product-price">
                                                R$ {product.price.toFixed(2)}
                                            </div>
                                        </div>

                                        {/* WhatsApp Button */}
                                        <a
                                            href={`${process.env.REACT_APP_BACKEND_API}/tracker?p=${encodeURIComponent(
                                                `Esta peça esta disponível ?\n${product.name}\nR$ ${product.price.toFixed(2)}\n${window.location.origin}/${product.category}/${product.id}`
                                            )}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="btn btn-success mt-2"
                                            onClick={handleRecaptchaClick}
                                        >
                                            Fale com a Val!
                                        </a>
                                    </div>
                                )) :
                                    <ReactLoading id="loading" type={'bubbles'} color={'#000000'} height={50} width={50} />
                                }
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            <ImageLightbox 
                imageUrl={lightboxImage} 
                isOpen={!!lightboxImage} 
                onClose={() => setLightboxImage(null)} 
            />
        </>
    );
};

export default Section;